module.exports = __webpack_public_path__ + "static/media/chatblack.7bf840f6.svg";